// src/admin/components/AdBannersTable.jsx

import { useTheme } from "../../context/ThemeContext";

export default function BannersTable({
    banners,
    onEdit,
    onDelete,
    deletingId,
}) {

    const { isDark } = useTheme();

    return (

        <div
            className={`
                overflow-hidden
                rounded-3xl
                border
                ${
                    isDark
                        ? "border-white/10"
                        : "border-gray-200"
                }
            `}
        >

            <table className="w-full">

                <thead
                    className={
                        isDark
                            ? "bg-white/5"
                            : "bg-gray-50"
                    }
                >

                    <tr>

                        <th className="p-4 text-left">
                            Title
                        </th>

                        <th className="p-4 text-left">
                            Placement
                        </th>

                        <th className="p-4 text-left">
                            Status
                        </th>

                        <th className="p-4 text-left">
                            Actions
                        </th>

                    </tr>

                </thead>

                <tbody>

                    {banners.length === 0 ? (

                        <tr>

                            <td
                                colSpan={4}
                                className="
                                    p-8
                                    text-center
                                    opacity-60
                                "
                            >
                                No banners found.
                            </td>

                        </tr>

                    ) : (

                        banners.map((banner) => (

                            <tr
                                key={banner.id}
                                className={`
                                    border-t
                                    ${
                                        isDark
                                            ? "border-white/10"
                                            : "border-gray-200"
                                    }
                                `}
                            >

                                <td className="p-4 font-medium">
                                    {banner.title}
                                </td>

                                <td className="p-4 capitalize">
                                    {banner.placement.replace("_", " ")}
                                </td>

                                <td className="p-4">

                                    <span
                                        className={`
                                            rounded-full
                                            px-3
                                            py-1
                                            text-xs
                                            font-medium
                                            ${
                                                banner.is_active
                                                    ? "bg-green-100 text-green-700"
                                                    : "bg-red-100 text-red-700"
                                            }
                                        `}
                                    >
                                        {banner.is_active
                                            ? "Active"
                                            : "Inactive"}
                                    </span>

                                </td>

                                <td className="p-4">

                                    <div className="flex gap-3">

                                        <button
                                            onClick={() => onEdit(banner)}
                                            className="text-cyan-500"
                                        >
                                            Edit
                                        </button>

                                        <button
                                            onClick={() =>
                                                onDelete(banner.id)
                                            }
                                            disabled={
                                                deletingId === banner.id
                                            }
                                            className="
                                                text-red-500
                                                disabled:opacity-50
                                            "
                                        >
                                            {deletingId === banner.id
                                                ? "Deleting..."
                                                : "Delete"}
                                        </button>

                                    </div>

                                </td>

                            </tr>

                        ))

                    )}

                </tbody>

            </table>

        </div>

    );

}